export const brandConfigObjectMap = new Map();

export const Brands = {
    BattleLeagueGamingMalaysia: 'blg-my-en'
}

export const SourceGroups = Object.freeze({
    Penrose: 'penrose',
});

brandConfigObjectMap.set(Brands.BattleLeagueGamingMalaysia, {
    debug: `${process.env.VUE_APP_DEBUG_OPTION}` || false,
    assetBrand: 'blg-my-en',
    sourceGroup: SourceGroups.Penrose,
    serviceFamily: 'blg',
    tabTitle: 'Battle League Gaming',
    productId: 329,
    countryCode: 'MY',
    siteCode: 'STBattleLeagueGaming1266844',
    productName: 'BattleLeagueGaming',
    subscribePrice: '5.00',
    currencyCode: 'MYR',
    priceLabel: 'RM5.00 / week',
    price: 'RM5.00',
    priceSuffix: 'per week · recurring',
    landingHeading: 'PLAY. COMPETE. WIN.',
    landingBody: 'Join Battle League gaming and compete in mobile gaming tournaments, climb the leaderboards and earn rewards.',
    landingCtaLabel: 'OPT-IN & SUBSCRIBE',
    thankYouHeading: 'WELCOME TO BLG!',
    thankYouBody: 'Thank you for subscribing to the Battle League Gaming service. You can now access the content.',
    thankYouCtaLabel: 'CONTINUE TO BLG',
    errorHeading: 'SOMETHING WENT WRONG',
    errorText: 'We could not complete your subscription. Please try again.',
    errorCtaLabel: 'TRY AGAIN',
    buttonColor: '#B3F50D',
    buttonTextColor: '#000000',
    gtmIdentifier: 'GTM-KR36598F',
    platformUrl: 'https://my.blg.gg',
    termsAndConditionsUrl: 'https://my.blg.gg/terms-conditions'
});
